module.exports = __webpack_public_path__ + "img/belt_of_strength.136cd7a7.png";